import axios from 'axios';
import { refreshAccessToken, TOKEN_REFRESH_PATH } from './utils/auth';
import { getAccessToken, getRefreshToken } from './utils/auth-storage';

const AUTH_REQUEST_PATHS = ['/api/login/', TOKEN_REFRESH_PATH];

function shouldSkipTokenRefresh(config) {
  const url = config?.url || '';
  return AUTH_REQUEST_PATHS.some((path) => url.includes(path));
}

axios.interceptors.request.use(
  async (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !shouldSkipTokenRefresh(originalRequest) &&
      getRefreshToken()
    ) {
      originalRequest._retry = true;
      const newAccessToken = await refreshAccessToken();
      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
      return axios(originalRequest);
    }
    return Promise.reject(error);
  }
);
